import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

const unwrap = (response) => response.data?.payload ?? response.data?.data ?? response.data;

export const getFinancialAccounts = async () => unwrap(await axiosInstance.get('/cash-ledger/accounts'));

export const createFinancialAccount = async (payload) => unwrap(await axiosInstance.post('/cash-ledger/accounts', payload));

export const deleteFinancialAccount = async (accountId) => (
  unwrap(await axiosInstance.delete(`/cash-ledger/accounts/${accountId}`))
);

export const createCashLedgerTransaction = async (payload) => (
  unwrap(await axiosInstance.post('/cash-ledger/transactions', payload))
);

export const createCashLedgerTransfer = async (payload) => (
  unwrap(await axiosInstance.post('/cash-ledger/transfers', payload))
);

export const getCashLedgerReport = async (filters) => (
  unwrap(await axiosInstance.post('/cash-ledger/report', filters))
);
